import {inject, injectable} from 'inversify';

import type {FileModel} from '../../../../domain/File/File.model';
import type {ReadFileQuery} from '../ReadFile.query';

import {fileStore} from '../../../../../api/media/file';
import {FileMapperJrpc} from '../../../../domain/File/mappers/File.mapper.jrpc';

@injectable()
export class ReadFileQueryJrpc implements ReadFileQuery {
  constructor(
    @inject(FileMapperJrpc) private readonly mapper: FileMapperJrpc,
  ) {}

  async exec(props: ReadFileQuery.Props): Promise<FileModel> {
    const {authorId = null, fileId} = props;

    const expand = this.mapper.expand.getByEnv();

    const response = await fileStore.fetch({
      _id: fileId,
      author_id: authorId,
      expand,
    });

    return this.mapper.mapDataToModel(response);
  }
}
